"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavbarLink = exports.NavbarItem = void 0;
const merge_1 = __importDefault(require("lodash/merge"));
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const components_common_link_1 = require("@hotelplan/components.common.link");
const components_common_router_link_1 = require("@hotelplan/components.common.router-link");
const libs_context_ios_scroll_block_1 = require("@hotelplan/libs.context.ios-scroll-block");
const MobileNavBarList = styled_components_1.default.ul.attrs({
    ['data-id']: `mobile-nav-bar-list`,
    className: 'mobile-nav-bar-list',
})(({ isChildren }) => ({
    paddingBottom: !isChildren ? '115px' : '0px',
}));
const MobileLink = (0, styled_components_1.default)(components_common_link_1.Link)({
    ':hover': {
        color: 'inherit',
    },
});
const Navbar = styled_components_1.default.nav(({ theme }) => theme.menu.headerMenu || {}, {
    flexDirection: 'column',
});
exports.NavbarItem = styled_components_1.default.li(({ theme }) => theme.menu.navBarItem || {});
exports.NavbarLink = (0, styled_components_1.default)(MobileLink)(({ active, theme, theme: { colors } }) => (0, merge_1.default)({}, {
    color: active ? colors.primary : undefined,
}, theme.menu.navBarLink || {}));
const MobileNavigationMenu = ({ links = [], children, highlightActiveItem, route, onClick, className, isListView = false, linkIconName = `chevron-long-right`, }) => {
    const ulRef = (0, react_1.useRef)(null);
    (0, libs_context_ios_scroll_block_1.useScrollElement)(ulRef);
    return (react_1.default.createElement(Navbar, { className: className },
        react_1.default.createElement(MobileNavBarList, { isChildren: Boolean(children) }, links.map((link, i) => {
            var _a, _b;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(LinkItem, { key: `mobile-menu-link-${i}`, id: `mobile-menu-link`, link: link, active: highlightActiveItem && route === ((_a = link.link) === null || _a === void 0 ? void 0 : _a.href), onClick: e => onClick === null || onClick === void 0 ? void 0 : onClick(e, link, i), linkIconName: linkIconName }),
                ((_b = link.subLinks) === null || _b === void 0 ? void 0 : _b.length) && isListView ? (react_1.default.createElement(react_1.default.Fragment, null, link.subLinks.map((sublink, index) => (react_1.default.createElement(LinkItem, { key: `mobile-menu-sub-link-${index}`, id: `mobile-menu-sub-link`, link: sublink, showIcon: true, onClick: e => onClick === null || onClick === void 0 ? void 0 : onClick(e, sublink, i), className: "navbar-sublink", linkIconName: linkIconName }))))) : null));
        })),
        children));
};
function LinkItem({ id, link, active = false, showIcon = false, className, onClick, linkIconName, }) {
    var _a;
    return (react_1.default.createElement("li", { "data-id": id },
        react_1.default.createElement(components_common_router_link_1.RouterLink, Object.assign({}, link.link, { passHref: true }),
            react_1.default.createElement(exports.NavbarLink, { active: active, target: link.target, onClick: onClick, className: className },
                link.label,
                ((_a = link.subLinks) === null || _a === void 0 ? void 0 : _a.length) || showIcon ? (react_1.default.createElement(components_common_icon_1.Icon, { className: "sub-link-chevron", name: linkIconName })) : null))));
}
exports.default = MobileNavigationMenu;
//# sourceMappingURL=MobileNavigationMenu.js.map